// Central content + imagery for the Yas Solutions landing page.
import {
  MonitorSmartphone,
  Rocket,
  Sparkles,
  Search,
  Palette,
  LifeBuoy,
  LayoutTemplate,
  RefreshCw,
  ShoppingCart,
  Smartphone,
  Wrench,
  Globe,
} from "lucide-react";

export const CONTACT = {
  email: "yassolution.ca@gmail.com",
  phone: "782-774-9901",
  phoneHref: "+17827749901",
  location: "Serving small businesses across Canada — remote & on-site",
};

export const NAV_LINKS = [
  { label: "Home", id: "home" },
  { label: "Services", id: "services" },
  { label: "Sectors", id: "portfolio" },
  { label: "Process", id: "process" },
  { label: "About", id: "about" },
  { label: "Contact", id: "contact" },
];

export const MARQUEE_ITEMS = [
  "Mobile Responsive",
  "Fast Loading",
  "Modern UX",
  "SEO Friendly",
  "Custom Design",
  "Ongoing Support",
  "Conversion Focused",
];

export const BENEFITS = [
  {
    icon: MonitorSmartphone,
    title: "Mobile-Responsive Design",
    text: "Pixel-perfect on every screen — phones, tablets and desktops — so no customer ever slips away.",
  },
  {
    icon: Rocket,
    title: "Fast Loading Speed",
    text: "Performance-tuned builds that load in a blink, keeping visitors engaged and rankings high.",
  },
  {
    icon: Sparkles,
    title: "Modern User Experience",
    text: "Clean, intuitive interfaces that guide visitors effortlessly toward becoming customers.",
  },
  {
    icon: Search,
    title: "Search-Engine Friendly",
    text: "Structured, semantic code and best-practice SEO so the right people actually find you.",
  },
  {
    icon: Palette,
    title: "Custom Design",
    text: "Never a template. Every site is tailored to your brand, your goals and your audience.",
  },
  {
    icon: LifeBuoy,
    title: "Ongoing Support",
    text: "We don't disappear at launch — count on us for updates, fixes and improvements.",
  },
];

export const SERVICES = [
  {
    icon: Globe,
    title: "Business Websites",
    text: "Credibility-building websites that turn first impressions into new business.",
  },
  {
    icon: LayoutTemplate,
    title: "Landing Pages",
    text: "High-converting single pages engineered for campaigns, launches and lead generation.",
  },
  {
    icon: RefreshCw,
    title: "Website Redesigns",
    text: "Breathe new life into an outdated site with a modern, faster, better-converting rebuild.",
  },
  {
    icon: ShoppingCart,
    title: "E-commerce Websites",
    text: "Sleek online stores with smooth checkouts that make it easy for customers to buy.",
  },
  {
    icon: Smartphone,
    title: "Mobile Optimization",
    text: "Flawless mobile experiences that capture the majority of today's web traffic.",
  },
  {
    icon: Wrench,
    title: "Maintenance & Support",
    text: "Reliable care plans keeping your site secure, updated and running at full speed.",
  },
];

export const PORTFOLIO = [
  {
    slug: "landscaping",
    category: "Landscaping & Outdoor Services",
    description:
      "Lush, image-led sites for landscapers, garden designers and lawn-care crews — turning seasonal traffic into a steady stream of bookings.",
    image:
      "https://images.unsplash.com/photo-1591474200742-8e512e6f98f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmFsJTIwbGFuZHNjYXBpbmclMjByZWFsJTIwZXN0YXRlfGVufDB8fHx8MTc4NDA3Nzc4MXww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "restaurants",
    category: "Restaurants & Hospitality",
    description:
      "Elegant menu-forward experiences with online reservations that fill tables and keep regulars coming back.",
    image:
      "https://images.unsplash.com/photo-1780181612148-20a394ff0dff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxmaW5lJTIwZGluaW5nJTIwcmVzdGF1cmFudCUyMGRhcmslMjBtb2Rlcm58ZW58MHx8fHwxNzg0MDc3Nzg3fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "consulting",
    category: "Consulting & Professional Services",
    description:
      "Polished corporate presences that position boutique firms as the obvious, credible choice for their clients.",
    image:
      "https://images.unsplash.com/photo-1783125127195-46eaaac89437?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmFsJTIwbGFuZHNjYXBpbmclMjByZWFsJTIwZXN0YXRlfGVufDB8fHx8MTc4NDA3Nzc4MXww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "fitness",
    category: "Fitness & Wellness",
    description:
      "High-energy studio and gym websites with class schedules and sign-ups engineered to grow memberships month over month.",
    image:
      "https://images.unsplash.com/photo-1762017740727-86f6ad9eab18?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxneW0lMjBmaXRuZXNzJTIwdHJhaW5pbmclMjBkYXJrJTIwbW9kZXJufGVufDB8fHx8MTc4NDA3Nzc4N3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "local-services",
    category: "Local Services & Trades",
    description:
      "Trust-first websites with instant quote requests that keep home-service crews and local trades fully booked.",
    image:
      "https://images.unsplash.com/photo-1676210134188-4c05dd172f89?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxwbHVtYmVyJTIwd29ya2VyJTIwbG9jYWwlMjBzZXJ2aWNlJTIwbW9kZXJufGVufDB8fHx8MTc4NDA3Nzc4N3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "e-commerce",
    category: "E-commerce & Retail",
    description:
      "Sleek online storefronts and frictionless checkouts designed to lift online sales without adding friction for the shopper.",
    image:
      "https://images.unsplash.com/photo-1487338875411-8880f74114a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjB3ZWJzaXRlJTIwZGVzaWduJTIwbW9ja3VwJTIwZGVza3RvcHxlbnwwfHx8fDE3ODQwNzc3ODF8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const PROCESS = [
  {
    step: "01",
    title: "Discovery & Consultation",
    text: "We start by understanding your business, goals and audience — a free, no-pressure conversation.",
  },
  {
    step: "02",
    title: "Design & Planning",
    text: "We map the structure and craft a modern design tailored to your brand, reviewed together.",
  },
  {
    step: "03",
    title: "Development & Testing",
    text: "We build your responsive, fast, SEO-ready site and rigorously test it across every device.",
  },
  {
    step: "04",
    title: "Launch & Support",
    text: "We launch with care and stay on to support, refine and grow your site over time.",
  },
];

export const WHY_CHOOSE = [
  { title: "Personalized Service", text: "You work directly with us — no account-manager runaround, ever." },
  { title: "Modern, Professional Designs", text: "Distinctive designs that make small businesses look like industry leaders." },
  { title: "Clear Communication", text: "Plain language, honest timelines and updates you'll actually understand." },
  { title: "Transparent Pricing", text: "Affordable, upfront quotes with zero surprise fees down the line." },
  { title: "Fast Delivery", text: "Efficient workflows get your site live quickly — without cutting corners." },
  { title: "Built Around Your Goals", text: "Every decision is anchored to what actually grows your business." },
];

export const TESTIMONIALS = [
  {
    name: "Sarah Mitchell",
    company: "Evergreen Grounds",
    rating: 5,
    quote:
      "Yas Solutions completely transformed how customers find us. Our booking requests nearly doubled within two months of launch.",
    image:
      "https://images.unsplash.com/photo-1769636929231-3cd7f853d038?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdCUyMHBvcnRyYWl0JTIwZGFyayUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzg0MDc3NzgwfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "David Chen",
    company: "Northpoint Advisory",
    rating: 5,
    quote:
      "Professional from the first call to launch. The site looks incredible and finally reflects the quality of our work.",
    image:
      "https://images.unsplash.com/photo-1765776830139-72b2184dae5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdCUyMHBvcnRyYWl0JTIwZGFyayUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzg0MDc3NzgwfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Amara Johnson",
    company: "Forge Strength Co.",
    rating: 5,
    quote:
      "Fast, responsive and genuinely easy to work with. They understood our vision and delivered ahead of schedule.",
    image:
      "https://images.pexels.com/photos/31869537/pexels-photo-31869537.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const WEBSITE_TYPES = [
  "Business Website",
  "Landing Page",
  "Website Redesign",
  "E-commerce Website",
  "Mobile Optimization",
  "Maintenance & Support",
  "Not sure yet",
];

export const BUDGET_RANGES = [
  "Under $1,000",
  "$1,000 – $3,000",
  "$3,000 – $6,000",
  "$6,000 – $10,000",
  "$10,000+",
  "Let's discuss",
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1654198340681-a2e0fc449f1b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxkYXJrJTIwbW9kZXJuJTIwYWJzdHJhY3QlMjAzZCUyMG5lb258ZW58MHx8fHwxNzg0MDc3NzgxfDA&ixlib=rb-4.1.0&q=85";
